import { Controltype, Formaat, IndienenVragenboomResponse, Vraag, Vraagtype } from '@models/claims';
import { IBaseVraagboomResultaat, VraagboomAntwoord, VraagboomSelectieResultaat } from '@models/vragenboom';
import { FormatHelper } from './format-helper';

export class VraagHelper {
  static isEindvraag(vraag: Vraag): boolean {
    if (!vraag) {
      return false;
    }

    if (vraag.eindvraag) {
      return true;
    }

    if (vraag.connectedVragen) {
      return vraag.connectedVragen.findIndex(v => v.eindvraag) >= 0;
    }

    return false;
  }

  static isEindvraagInProces(vraag: Vraag): boolean {
    if (!vraag) {
      return false;
    }

    if (vraag.vraagtype === Vraagtype.EindeProcesSucces ||
      vraag.vraagtype === Vraagtype.EindeProcesNietGedekt ||
      vraag.vraagtype === Vraagtype.EindeProcesEmail) {
      return true;
    }

    if (vraag.connectedVragen) {
      return vraag.connectedVragen.findIndex(v =>
        v.vraagtype === Vraagtype.EindeProcesSucces ||
        v.vraagtype === Vraagtype.EindeProcesNietGedekt ||
        v.vraagtype === Vraagtype.EindeProcesEmail) >= 0;
    }

    return false;
  }

  static geefTitel(titel: string, alleResultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[]): string {
    if (!titel) {
      return '';
    }

    let index = titel.indexOf('{');
    let vervangen = false;

    while (index > -1) {
      vervangen = false;
      let indexSluit = titel.indexOf('}');
      if (indexSluit < 0) {
        index === -1;
      } else {
        const variabele = titel.substring(index, indexSluit + 1);

        for (const resultaat of alleResultaten) {
          if (!vervangen && resultaat.vraag.antwoorden?.length === 1 &&
            (resultaat.vraag.control === Controltype.Telefoon1 || resultaat.vraag.control === Controltype.Telefoon2 || resultaat.vraag.control === Controltype.Telefoon3)) {
            var selectieResultaat = resultaat as VraagboomAntwoord<VraagboomSelectieResultaat>;

            resultaat.vraag.antwoorden[0].variabeleWaarden.forEach((varWaarde: string) => {
              if (varWaarde === variabele) {
                titel = titel.replace(variabele, selectieResultaat.resultaat.displayValue);
                vervangen = true;
              }
            });
          }
        }
        if (!vervangen) {
          // fallback
          titel = titel.replace(variabele, '');
        }
        index = titel.indexOf('{', index);
      }
    }
    return titel;
  }

  static hasVraagType(vraag: Vraag, vraagtype: Vraagtype): boolean {
    if (!vraag) {
      return false;
    }

    if (vraag.vraagtype === vraagtype) {
      return true;
    }

    if (vraag.connectedVragen) {
      return vraag.connectedVragen.findIndex(v => v.vraagtype === vraagtype) >= 0;
    }

    return false;
  }

  static isComplexType(vraag: Vraag): boolean {
    if (!vraag) {
      return false;
    }

    return vraag.vraagtype === Vraagtype.Open ||
      vraag.vraagtype === Vraagtype.OpenN ||
      vraag.vraagtype === Vraagtype.Foto ||
      vraag.vraagtype === Vraagtype.Upload;
  }

  static checkVariabeleWaarden(str: string, metEuroteken: boolean, formaat: Formaat, vragenboomResponse: IndienenVragenboomResponse): string {
    let regex = /\{(.*?)\}/;
    let accolades = str.match(regex);

    while (accolades?.length > 1) {
      let variabele = accolades[1].replace('soortLijst.', '');
      // controleer of formaat na variabele zit
      let variabeleSplit = variabele.split(':');
      if (variabeleSplit.length > 1) {
        variabele = variabeleSplit[0];
        formaat = variabeleSplit[1] as Formaat;
      }
      str = str.replace(accolades[0], this.geefWaardeUitLijst(vragenboomResponse, variabele, formaat, metEuroteken));
      accolades = str.match(regex);
    }
    return str;
  }

  static geefWaardeUitLijst(vragenboomResponse: IndienenVragenboomResponse, variabele: string, formaat: Formaat, metEuroteken: boolean): string {
    // variabele bevat bijvoorbeeld Berekening.Rekeningnummer
    let splitInput = variabele.split('.'); // [Berekening, Rekeningnummer]
    if (splitInput?.length > 0) {
      // root van het pad, bijvoorbeeld antwoord
      let obj = this.zoekObject(splitInput, vragenboomResponse);
      if (obj || obj === 0) {
        return this.formateerWaarde(obj, formaat, metEuroteken);
      }
    }
    return '';
  }

  private static zoekObject(splitInput: string[], obj: any) {
    splitInput.forEach((str: any) => {
      if (obj) {
        obj = obj[str];
      }
    });
    return obj;
  }

  private static formateerWaarde(obj: any, formaat: Formaat, metEuroteken: boolean): string {
    if (formaat === Formaat.Bedrag || formaat === Formaat.BedragNegatief || formaat === Formaat.BedragTotaal) {
      return metEuroteken ? '<span class="inline">' + FormatHelper.formatCurrency(obj, "EUR") + '</span>' : obj.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } else if (formaat === Formaat.Percentage) {
      return obj.toLocaleString('nl-NL', { maximumFractionDigits: 2 }) + "%";
    } else {
      return obj.toString();
    }
  }
}
